export enum HomePageView {
  EMPLOYEE_VIEW = "employee_view",
  EDIT_LAYOUT_VIEW = "edit_layout_view",
  EDIT_CONTENT_VIEW = "edit_content_view"
}

export enum RowNames {
  TWO_EQUAL = "two_equal",
  THREE_EQUAL = "three_equal",
  FOUR_EQUAL = "four_equal"
}
